import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "tax-code-title" };
const _hoisted_2 = {
    key: 1,
    class: "tax-code-headline tax-code-ai"
};
const _hoisted_3 = { class: "tax-code-headline" };
const _hoisted_4 = { class: "tax-code-reasons" };
const _hoisted_5 = {
    key: 3,
    class: "tax-code-actions"
};
import { ref, computed, watch, onUnmounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useChat } from '@/composables/useChat';
import { explainTaxCode, taxCodePrompt } from '@/utils/taxCode';
import { processMonetaryAmounts } from '@/utils/helpers';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TaxCodeCard',
    props: {
        code: {},
        taxYear: {}
    },
    emits: ["ask"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const state = useAppState();
        const { sendSessionlessChatMessage } = useChat();
        const explanation = computed(() => explainTaxCode(props.code, v => state.formatter.format(v, false, false), props.taxYear));
        // The AI writes the explanation; the fixed text above is the fallback if it errors, comes back empty or takes over 20s.
        const aiText = ref('');
        const loading = ref(false);
        let request = 0;
        function explainWithAi() {
            const id = ++request;
            aiText.value = '';
            loading.value = explanation.value.variant !== 'unreadable';
            if (!loading.value)
                return;
            // Only the latest request may update the card, so a slow reply for an older code is ignored.
            const finish = (text) => {
                if (id !== request)
                    return;
                clearTimeout(timer);
                aiText.value = text;
                loading.value = false;
            };
            const timer = setTimeout(() => finish(''), 20000);
            sendSessionlessChatMessage(taxCodePrompt(props.code, props.taxYear), (res) => finish(String(res?.body || '').replace(/\*\*/g, '').trim()), () => finish(''));
        }
        watch(() => [props.code, props.taxYear], explainWithAi, { immediate: true });
        onUnmounted(() => request++);
        // HMRC's "check your Income Tax" page shows the breakdown behind the code, and links to the HMRC app.
        function checkWithHmrc() {
            window.open('https://www.gov.uk/check-income-tax-current-year', '_blank');
        }
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tax-code-card", `tax-code-card--${explanation.value.variant}`])
            }, [
                _createElementVNode("span", _hoisted_1, "Tax code " + _toDisplayString(_ctx.code.trim()), 1),
                (loading.value)
                    ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                        key: 0,
                        type: "paragraph",
                        class: "tax-code-skeleton"
                    }))
                    : (aiText.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(processMonetaryAmounts)(aiText.value)), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(explanation.value.headline), 1),
                            (explanation.value.reasons.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "tax-code-text" }, "This could be because of one of these:", -1)),
                                    _createElementVNode("ul", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explanation.value.reasons, (reason) => {
                                            return (_openBlock(), _createElementBlock("li", { key: reason }, _toDisplayString(reason), 1));
                                        }), 128))
                                    ])
                                ], 64))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explanation.value.notes, (note) => {
                                return (_openBlock(), _createElementBlock("p", {
                                    key: note,
                                    class: "tax-code-text"
                                }, _toDisplayString(note), 1));
                            }), 128))
                        ], 64)),
                (explanation.value.variant !== 'standard')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (explanation.value.variant !== 'unreadable')
                            ? (_openBlock(), _createBlock(MGButton, {
                                key: 0,
                                text: "Check your code with HMRC",
                                fullWidth: true,
                                stacked: true,
                                onClick: checkWithHmrc,
                                noCaps: true
                            }))
                            : _createCommentVNode("", true),
                        _createVNode(MGButton, {
                            text: "Ask about my tax code",
                            outline: true,
                            fullWidth: true,
                            stacked: true,
                            onClick: _cache[0] || (_cache[0] = ($event) => (emit('ask', explanation.value.question))),
                            noCaps: true
                        })
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
